import React, { useState, useEffect } from 'react'
import { SvgIcon, SvgType } from 'src/components/shared/SvgIcon/SvgIcon'



export const SessionState = ({ secondsTillStart, durationInSeconds }) => {
  const fifteenMinutes = 900
  const [timer, setTimer] = useState(secondsTillStart-fifteenMinutes)
  const [startTime, setStartTime] = useState(Date.now()+((secondsTillStart-fifteenMinutes)*1000))

  useEffect(() => {
    setTimeout(() => {
      setTimer(Math.round((startTime - Date.now())/1000))
    }, 1000);
  })
  
  if (timer <= 0 && timer + (durationInSeconds+fifteenMinutes) >= 0) {
    return (
      <div className="iconContainer">
        <SvgIcon type={SvgType.LIVE} fill="#ff2f46" />
        <p className="my-2" style={{color: "#ff2f46"}}>LIVE</p>
      </div>
    )
  } 

  if (timer > 0) {
    return (
      <div className="iconContainer">
        <SvgIcon type={SvgType.LIVE} fill="#009DA3" />
        <p className="my-2" style={{color: '#009DA3'}}>STARTING SOON</p>
      </div>
    )
  }
  return (
    <div className="iconContainer">
      <SvgIcon type={SvgType.REPLAY} fill="#505C7C" />
      <p className="my-2" style={{color: "#505C7C"}}>ENDED</p>
    </div>
  )
}